import React, { useState } from "react";
import Layout from "../form-layout";

const OPTIONS = [
  "Continue my current medication and dose",
  "Continue my medication but increase the dose",
  "Continue my medication but reduce the dose",
  "Switch to a different weight-loss medication",
  "Restart after missing doses / a treatment interruption",
  "I would like the doctor to advise me",
];

// Form B Q6 — "What would you like to do with your treatment?"
export default function TreatmentIntent({ formData, setFormData, onBack, goToStep }) {
  const [intent, setIntent] = useState(formData.treatmentIntent || "");

  // The side-effect module (b5a) is skipped when Q5 = "No", so going back has to jump
  // straight to the Q5 gate too — default index-based onBack would otherwise land on
  // the skipped module screen instead.
  const handleBack = () => {
    if (formData.hasCurrentSideEffects === "No") {
      goToStep("b5");
    } else {
      onBack();
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!intent) return;

    setFormData((prev) => ({ ...prev, treatmentIntent: intent }));
    localStorage.setItem("treatmentIntent", intent);

    goToStep("b7");
  };

  return (
    <Layout goToStep={goToStep} onBack={handleBack}>
      <h2 className="text-sm sm:text-[14px] font-medium text-[#000000] mb-6">
        What would you like to do with your treatment?
      </h2>

      <form onSubmit={handleSubmit} className="flex flex-col gap-3">
        {OPTIONS.map((option) => (
          <label key={option} className="flex items-center gap-2 p-3 rounded-lg cursor-pointer border transition-all text-sm">
            <input
              type="radio"
              name="treatmentIntent"
              checked={intent === option}
              onChange={() => setIntent(option)}
              className="h-4 w-4 accent-sky-400 cursor-pointer"
            />
            <span>{option}</span>
          </label>
        ))}

        <div className="flex justify-start mt-4">
          <button
            type="submit"
            disabled={!intent}
            className={`w-[210px] text-sm font-semibold rounded-lg py-3 transition-colors
              ${!intent ? "bg-gray-300 text-gray-600 cursor-not-allowed" : "bg-[#35C3D9] text-white hover:bg-[#27AAC0]"}`}
          >
            Next →
          </button>
        </div>
      </form>
    </Layout>
  );
}
